import React from 'react'
import { Form, FormGroup, InputGroup, Button, Input, Row } from 'reactstrap'
import Loader from 'react-loader-spinner'
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment'
import '../../../stylesheets/Provision.css'
import '../../../stylesheets/Reports.css'
import { TOKEN_STORAGE_KEY, getStorage } from "../../../dataHelpers/authenticationHelpers"
import { subscriptionHelpers } from '../../../dataHelpers';
import { AppError } from "../../../models"
import { ErrorModal } from '../../ui'
import ExpireControllersReport from '../../ui/ExpireControllersReport'
import PaymentsReport from '../../ui/PaymentsReport'
import { getAllTeams } from "../../../api"
import {
    NOT_FOUND, NO_VALUE_SELECT, SELECT_OPTIONS, ABOUT_CON_NOT_FOUND, EXPIRED_CON_NOT_FOUND,
    PAY_DATA_NOT_FOUND, RENEWED_CON_NOT_FOUND, SELECT_START_DATE, SELECT_END_DATE
} from '../../../constants'

class Reports extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            errors: [],
            loading: false,
            selectedOptions: '',
            expiredControllers: null,
            selectOptionsval: null,
            paymentData: null,
            teams: [],
            startDate: '',
            endDate: '',
            isClearStartDate: false,
            isClearEndDate: false
        }
        this.token = (props.token || JSON.parse(getStorage().getItem(TOKEN_STORAGE_KEY)))
        this.handleSubmit = this.handleSubmit.bind(this)
    }

    showDropdown() {
        this.setState({ showDropdown: true })
    }

    componentDidMount() {
        this.fetchTeamsState(this.token)
    }

    startDateChange = (date) => {
        this.setState({
            startDate: date,
            isClearStartDate: true
        });
    }

    endDateChange = (date) => {
        this.setState({
            endDate: date,
            isClearEndDate: true
        });
    }

    async fetchTeamsState(token) {
        try {
            let { results } = await getAllTeams(token, 1, true, true, false, 10000)
            this.setState({ teams: results })
        } catch (error) {
            console.log(error)
        }
    }

    async handleSubmit(e) {
        e.preventDefault()
        this.setState({
            loading: true,
            expiredControllers: null,
            selectOptionsval: null,
            paymentData: null
        })
        try {
            let optionsVal = this.state.selectedOptions
            if (optionsVal === null || optionsVal == '') {
                let appError = new AppError(NO_VALUE_SELECT, SELECT_OPTIONS)
                await this.setState({
                    errors: [appError],
                    loading: false,
                    startDate: '',
                    endDate: '',
                    isClearStartDate: false,
                    isClearEndDate: false
                })
                return
            } else {
                if (optionsVal === "1") {
                    let expiredResponse = await subscriptionHelpers.getExpiredControllers(this.token)
                    if (!expiredResponse.error) {
                        if (expiredResponse.length > 0) {
                            this.setState({
                                expiredControllers: expiredResponse,
                                selectOptionsval: optionsVal,
                                loading: false,
                                startDate: '',
                                endDate: '',
                                isClearStartDate: false,
                                isClearEndDate: false
                            })
                        } else {
                            let appError = new AppError(NOT_FOUND, EXPIRED_CON_NOT_FOUND)
                            this.setState({
                                errors: [appError],
                                loading: false,
                                startDate: '',
                                endDate: '',
                                isClearStartDate: false,
                                isClearEndDate: false
                            })
                        }
                    } else {
                        this.setState({ errors: [expiredResponse.error] })
                    }
                } else if (optionsVal === "2") {
                    let expiringResponse = await subscriptionHelpers.getExpiringControllers(this.token)
                    if (!expiringResponse.error) {
                        if (expiringResponse.length > 0) {
                            this.setState({
                                expiredControllers: expiringResponse,
                                selectOptionsval: optionsVal,
                                loading: false,
                                startDate: '',
                                endDate: '',
                                isClearStartDate: false,
                                isClearEndDate: false
                            })
                        } else {
                            let appError = new AppError(NOT_FOUND, ABOUT_CON_NOT_FOUND)
                            this.setState({
                                errors: [appError],
                                loading: false,
                                startDate: '',
                                endDate: '',
                                isClearStartDate: false,
                                isClearEndDate: false
                            })
                        }
                    } else {
                        this.setState({ errors: [expiringResponse.error] })
                    }
                } else if (optionsVal === "3") {
                    let renewedResponse = await subscriptionHelpers.getRenewedControllers(this.token)
                    if (!renewedResponse.error) {
                        if (renewedResponse.length > 0) {
                            this.setState({
                                expiredControllers: renewedResponse,
                                selectOptionsval: optionsVal,
                                loading: false,
                                startDate: '',
                                endDate: '',
                                isClearStartDate: false,
                                isClearEndDate: false
                            })
                        } else {
                            let appError = new AppError(NOT_FOUND, RENEWED_CON_NOT_FOUND)
                            this.setState({
                                errors: [appError],
                                loading: false,
                                startDate: '',
                                endDate: '',
                                isClearStartDate: false,
                                isClearEndDate: false
                            })
                        }
                    } else {
                        this.setState({ errors: [renewedResponse.error] })
                    }
                } else if (optionsVal === "4") {
                    let startDateVal = this.state.startDate
                    let endDateVal = this.state.endDate
                    if (startDateVal === null || startDateVal === '') {
                        let appError = new AppError(NO_VALUE_SELECT, SELECT_START_DATE)
                        await this.setState({
                            errors: [appError],
                            loading: false
                        })
                        return
                    } else if (endDateVal === null || endDateVal === '') {
                        let appError = new AppError(NO_VALUE_SELECT, SELECT_END_DATE)
                        await this.setState({
                            errors: [appError],
                            loading: false
                        })
                        return
                    } else {
                        // Modify date format
                        let start_date = new Date(startDateVal)
                        let start_month = ((start_date.getMonth() + 1) < 10 ? '0' + (start_date.getMonth() + 1) : (start_date.getMonth() + 1))
                        let start_day = (start_date.getDate() < 10 ? '0' + start_date.getDate() : start_date.getDate())
                        let start_year = start_date.getFullYear()
                        let final_start_date = start_year + '-' + start_month + '-' + start_day

                        let end_date = new Date(endDateVal)
                        let end_month = ((end_date.getMonth() + 1) < 10 ? '0' + (end_date.getMonth() + 1) : (end_date.getMonth() + 1))
                        let end_day = (end_date.getDate() < 10 ? '0' + end_date.getDate() : end_date.getDate())
                        let end_year = end_date.getFullYear()
                        let final_end_date = end_year + '-' + end_month + '-' + end_day
                        let paymentReportResponse = await subscriptionHelpers.getPaymentsReport(this.token, final_start_date, final_end_date)
                        if (!paymentReportResponse.error) {
                            if (paymentReportResponse.length > 0) {
                                this.setState({
                                    paymentData: paymentReportResponse,
                                    loading: false
                                })
                            } else {
                                let appError = new AppError(NOT_FOUND, PAY_DATA_NOT_FOUND)
                                this.setState({
                                    errors: [appError],
                                    loading: false
                                })
                            }
                        } else {
                            this.setState({ errors: [paymentReportResponse.error] })
                        }
                    }
                }
            }
        } catch (error) {
            console.log(error)
        }
    }

    dismissError(error) {
        let errors = this.state.errors.filter((e) => e !== error)
        this.setState({ errors, loading: false })
    }

    render() {
        let { loading, errors, expiredControllers, selectOptionsval, paymentData, teams, isClearStartDate, isClearEndDate } = this.state
        return (<div className="row justify-content-center align-items-center">
                <div className="row justify-content-center align-items-center">
                    <h1 className="col-12 noprint">Generate Reports</h1>
                    <br />
                    {errors.map((appError, idx) =>
                        <ErrorModal key={`error-${appError.text}-${idx}`}
                                    modal={true}
                                    toggle={() => (this.dismissError(appError))}
                                    text={appError.text}
                                    title={appError.title} />
                    )}
                    <br />
                    {(loading ?
                            <Loader type="TailSpin" width={60} height={60} /> :
                            <Form onSubmit={this.handleSubmit} className="col-lg-8 col-md-8 col-sm-10 noprint">
                                <FormGroup>
                                    <br />
                                    <InputGroup>
                                        <Input type="select" name="selectTeam"
                                               value={this.state.selectedOptions}
                                               onChange={(evt) => this.setState({ selectedOptions: evt.target.value })
                                               }
                                        >
                                            <option value="">&ensp;Select Options</option>
                                            <option value="1">&ensp;Expired Controllers</option>
                                            <option value="2">&ensp;About To Expire Controllers</option>
                                            <option value="3">&ensp;Renewed Controllers</option>
                                            <option value="4">&ensp;Payment History</option>
                                        </Input>
                                    </InputGroup>
                                    {this.state.selectedOptions === "4" &&
                                    <div>
                                        <br />
                                        <Row>
                                            <div className="col-sm-6">
                                                <DatePicker
                                                    selected={this.state.startDate}
                                                    onChange={this.startDateChange}
                                                    placeholderText="Click to Select Start Date"
                                                    selectsStart
                                                    startDate={this.state.startDate}
                                                    endDate={this.state.endDate}
                                                    dateFormat="MM-DD-YYYY"
                                                    className="form-control"
                                                    isClearable={isClearStartDate}
                                                    maxDate={moment().add(0, "days")}
                                                />
                                            </div>
                                            <div className="col-sm-6">
                                                <DatePicker
                                                    selected={this.state.endDate}
                                                    onChange={this.endDateChange}
                                                    placeholderText="Click to Select End Date"
                                                    selectsEnd
                                                    startDate={this.state.startDate}
                                                    endDate={this.state.endDate}
                                                    dateFormat="MM-DD-YYYY"
                                                    className="form-control"
                                                    isClearable={isClearEndDate}
                                                    maxDate={moment().add(0, "days")}
                                                />
                                            </div>
                                        </Row>
                                    </div>
                                    }
                                </FormGroup>
                                <br />
                                <Button>View</Button>
                            </Form>
                    )}
                </div>
                <div className="row justify-content-center align-items-center">
                    {expiredControllers !== null &&
                    <ExpireControllersReport controllersData={expiredControllers} options={selectOptionsval} allteam={teams} />
                    }
                    {paymentData !== null &&
                    <PaymentsReport paymentsdata={paymentData} />
                    }
                </div>
            </div>
        )
    }
}

export default Reports


// WEBPACK FOOTER //
// ./src/components/pages/subscription/Reports.js